import { useLocation } from "@tanstack/react-router";
import { useEffect } from "react";
import { useEmbedMode } from "../utils/embed-detection";

export function EmbedMeta() {
  const location = useLocation();
  const embed = useEmbedMode();

  // biome-ignore lint/correctness/useExhaustiveDependencies: we need to re-run the effect when the embed mode changes
  useEffect(() => {
    if (embed) {
      // Add meta tag to prevent indexing in embed mode
      const existingMeta = document.querySelector('meta[name="robots"]');

      if (existingMeta) {
        existingMeta.setAttribute("content", "noindex, nofollow, noarchive, nosnippet");
      } else {
        const metaTag = document.createElement("meta");
        metaTag.name = "robots";
        metaTag.content = "noindex, nofollow, noarchive, nosnippet";
        document.head.appendChild(metaTag);
      }

      return () => {
        // Clean up when component unmounts or embed changes
        const metaTag = document.querySelector('meta[name="robots"]');
        if (
          metaTag &&
          metaTag.getAttribute("content") === "noindex, nofollow, noarchive, nosnippet"
        ) {
          metaTag.remove();
        }
      };
    }
    // Return undefined when not in embed mode
    return undefined;
  }, [embed, location.search]);

  return null;
}
